import React from 'react'
import classnames from 'classnames/bind'
import { Icon, IconProps, AutomationTarget } from '@adc/ui-core'
import styles from './styles.scss'

const cx = classnames.bind(styles)

export interface ActionIconProps extends IconProps, AutomationTarget {
  disabled?: boolean
}

/**
 * Actions that serve in function the same as a button, some sort of trigger to take an action. A common
 * pattern we employ is to render these inline alongside larger selection components.
 */
const ActionIcon: React.FC<ActionIconProps> = props => {
  return (
    <div
      className={cx('action-icon-container')}
      // @ts-ignore preserving old functionality, not sure if this disabled does anything on the div...
      disabled={Boolean(props.disabled)}
    >
      <div className={cx('action-icon-animation-helper')} />
      <Icon {...props} className={cx('action-icon')} />
    </div>
  )
}

export default ActionIcon
